export enum FreeLimitExceededError {
  RoutineLimitExceeded = 'Routine limit exceeded',
}

export { NetworkError } from '@littlebird/logger/error';
